import { useMutation } from "@tanstack/react-query";
import { type Api, updateWorkoutItemGroup } from "api-client";
import { useCallback } from "react";

import { useAuthenticatedNavigationContext } from "src/layout/AuthenticatedNavigationContext";
import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

export function useGroupUpdate(workoutItemId: string) {
  const workoutEditStore = useWorkoutEditStore();
  const { startSaving } = useAuthenticatedNavigationContext();

  const updateMutation = useMutation({
    mutationFn: async (body: Api.UpdateWorkoutItemGroup.Input["body"]) => {
      return await updateWorkoutItemGroup({
        path: {
          workoutId: workoutEditStore.workout.id,
          workoutItemId: workoutItemId,
        },
        body,
      });
    },
  });

  const handleUpdate = useCallback(
    async (updates: Api.UpdateWorkoutItemGroup.Input["body"]) => {
      const stopSaving = startSaving();
      workoutEditStore.updateWorkoutItem(workoutItemId, updates);

      try {
        await updateMutation.mutateAsync(updates);
        stopSaving();
      } catch {
        stopSaving("error");
      }
    },
    [startSaving, workoutEditStore, workoutItemId, updateMutation],
  );

  return { handleUpdate };
}
